module.exports = "/img/vendor/swipebox/src/loader.gif?0c4a35715c83df7e952869ff3a0da728";


//////////////////
// WEBPACK FOOTER
// ./node_modules/swipebox/src/img/loader.gif
// module id = Amqh
// module chunks = 0